'use client';

import type { HandleAddToCart } from '@app/pdp/types';
import {
    getNextApiRoute,
    typedFetch,
    type Basket,
    type ProductData,
} from '@libs/common-next';
import { HttpMethod } from '@libs/core';

const SFCC_CART_BASE_URL = getNextApiRoute('cart');

const fetchBasket = async <T = Basket | null>(
    url: string,
    method: HttpMethod,
    body?: ProductData
): Promise<T | null> =>
    typedFetch<T | null>(url, {
        method,
        body: body ? JSON.stringify(body) : undefined,
    });

export const handleAddToCart: HandleAddToCart = async (body, basketId) => {
    if (body.length && basketId) {
        return await fetchBasket<Basket | null>(
            `${SFCC_CART_BASE_URL}/${basketId}`,
            HttpMethod.POST,
            body
        );
    }

    return null;
};
